import chefAjayChopra from "../assets/images/chefs/chef-ajay-chopra.jpg";

export const chefImages = {
  chefAjayChopra,
};

export const chefBioData = [
  {
    id: "1",
    chefName: "Chef Ajay Chopra",
    chefBioSlug: "ajay-chopra",
    imageBgClass: "chef-ajay-chopra-bg",
    imageLink: "chefAjayChopra",
    chefBioDataParas: [
      "Chef Ajay is one of India's most respected culinary innovators. Born in Lucknow, he trained at IHM Goa and the Oberoi Centre, graduating as a gold medalist. His early career included leading kitchens at The Oberoi, JW Marriott, The Westin Mumbai, and London's Mint Leaf.",
      "As a judge on MasterChef India, he inspired millions with warmth and creativity. His YouTube series The Big Daddy Chef and 2022 cookbook promote family-centered cooking. His entrepreneurial ventures include founding Zion Hospitality (30+ restaurant projects) and launching Kshir & Canelé, which reinvents Indian sweets with French pastry techniques.",
      "In 2023, he curated millet-based desserts for the G20 First Spouses' Summit. Since 2022, he has been the current ambassador for the EU's More Than Food campaign, championing sustainability and farm-to-fork dining.",
      "Chef Ajay has been featured in Travel + Leisure India, Times of India, NDTV Food, Caterer Middle East, and Food & Beverage Business Review. He has also contributed to U.S. culinary platforms connected with Food Network and appeared at European culinary festivals.",
      "Beyond his accolades, Chef Ajay is a humble and genuine soul—a down-to-earth individual who saw the potential in two young dreamers and helped give their vision wings. He embodies the rare qualities of kindness and humanity that make him not just a phenomenal chef, but a remarkable human being.",
      "Today, he continues to inspire food lovers globally—showing that cooking is more than nourishment; it's connection, creativity, and commitment.",
    ],
  },
];
